import {useState, useCallback, ReactNode} from 'react'
import {ConfirmActionModal} from '../../../../gori/components'
import {useIntl} from 'react-intl'

type ModalInfo = {
  primaryText: string
  secondaryText: string
  title: string
  msg: ReactNode | string
}

export function useConfirmModal() {
  const intl = useIntl()

  const [visible, setVisible] = useState(false)
  const [resolver, setResolver] = useState<((value: boolean) => void) | null>(null)
  const [modalInfo, setModalInfo] = useState<ModalInfo>({
    primaryText: intl.formatMessage({id: 'CONFIRM'}),
    secondaryText: intl.formatMessage({id: 'CANCEL'}),
    title: intl.formatMessage({id: 'CONFIRMATION'}),
    msg: (
      <span className='fw-bold text-center'>
        <p>{intl.formatMessage({id: 'ARE_YOU_SURE_YOU_WANT_TO_PROCEED'})}</p>
        <p>
          {intl.formatMessage({
            id: 'THIS_ACTION_CANNOT_BE_UNDONE_PLEASE_REVIEW_CAREFULLY_BEFORE_PROCEEDING',
          })}
        </p>
      </span>
    ),
  })

  const confirm = useCallback((data?: Partial<ModalInfo>) => {
    if (data) {
      setModalInfo((prev) => ({
        ...prev,
        ...data,
      }))
    }

    setVisible(true)

    return new Promise<boolean>((resolve) => {
      setResolver(() => resolve)
    })
  }, [])

  const handleConfirm = useCallback(() => {
    setVisible(false)
    resolver?.(true)
  }, [resolver])

  const handleCancel = useCallback(() => {
    setVisible(false)
    resolver?.(false)
  }, [resolver])

  const ConfirmModal = (
    <ConfirmActionModal
      show={visible}
      title={modalInfo.title}
      message={modalInfo.msg}
      messagePrimary={modalInfo.primaryText}
      messageSecondary={modalInfo.secondaryText}
      handlePrimaryAction={handleConfirm}
      handleSecondaryAction={handleCancel}
      handleClose={handleCancel}
    />
  )

  return {confirm, ConfirmModal}
}
